import React, { useEffect, useState } from 'react';
import { ListGroup, Spinner, Alert } from 'react-bootstrap';
import { withBase, ROUTES } from '../config';

export default function DonationList({
  path = ROUTES.recent,
  refreshKey = 0,
}) {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState('');

  const truncate = (str, maxLen = 30) =>
    typeof str === 'string' && str.length > maxLen
      ? str.slice(0, maxLen - 3) + '...'
      : (str || '');

  useEffect(() => {
    setLoading(true);
    setError('');

    const url = withBase(path);

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}`);
        return res.json();
      })
      .then(data => {
        const list = Array.isArray(data) ? data : (data?.items || data?.donations || []);
        const normalized = list.map(d => ({
          name:        d.name ?? d.donorName ?? 'Anonymous',
          amount:      Number(d.amount ?? d.total ?? d.value ?? 0),
          dedicatedTo: d.dedicatedTo ?? d.inHonorOf ?? d.inMemoryOf ?? '',
          createdAt:   d.createdAt ?? d.date ?? ''
        }));
        setDonations(normalized);
      })
      .catch(err => setError(err.message || 'Failed to load recent donations'))
      .finally(() => setLoading(false));
  }, [path, refreshKey]); // limit removed

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" variant="light" />
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger" className="mt-3">{error}</Alert>;
  }

  return (
    <ListGroup variant="flush">
      {donations.map((d, i) => {
        const name        = truncate(d.name);
        const dedicatee   = (d.dedicatedTo || '').trim() ? truncate(d.dedicatedTo) : '';
        const amountLabel = Number(d.amount || 0).toLocaleString(undefined, {
          style: 'currency',
          currency: 'USD'
        });

        return (
          <ListGroup.Item
            key={i}
            className="d-flex justify-content-between align-items-start px-0 py-2 bg-transparent text-black"
            style={{ borderBottom: '1px solid rgba(255,255,255,0.2)' }}
          >
            <div>
              <div className="fw-bold">{name}</div>
              {dedicatee && (
                <div className="fst-italic" style={{ fontSize: '0.9rem' }}>
                  in honor of {dedicatee}
                </div>
              )}
            </div>
            <div className="fw-bold">{amountLabel}</div>
          </ListGroup.Item>
        );
      })}
    </ListGroup>
  );
}
